import React from 'react';
import FieldModal from '../../../../components/modals/fieldModal';
import InputField from '../../../../components/inputs/inputField';
import ViewsTable from '../../../../components/tables/ViewsTable';

class ConnectToSessions extends React.Component {
    constructor(props) {
        super(props);
        const columns = {
            name: 'Name',
            date: 'Date',
            startTime: 'Start Time',
            endTime: 'End Time',
            locationName: 'Location',
        };
        const columnTypes = {
            name: 'string',
            date: 'date',
            startTime: 'time',
            endTime: 'time',
            locationName: 'string',
        };
        const columnWidth = {
            name: 300
        };
        const toggledColumns = {};
        const normalizedColumns = Object.keys(columns).map((cfc) => {
            toggledColumns[cfc] = true;
            return {
                label: columns[cfc],
                key: cfc,
                value: cfc,
                type: columnTypes[cfc],
                sortAsc: false,
                sortDesc: false
            };
        });
        this.state = {
            submitting: false,
            success: false,
            selectedColumns: {},
            columnTypes: columnTypes,
            columns: columns,
            normalizedColumns: normalizedColumns,
            toggledColumns: toggledColumns,
            columnWidth: columnWidth,
            checkedSessions: {},
            searchTerm: ''
        };
    }



    updatedEditedValue = (key, value) => {
        this.setState({ editedValues: { ...this.state.editedValues, [key]: value } });
    }

    submit = async () => {
        const { checkedSessions } = this.state;
        this.setState({ submitting: true, success: false });
        let selectedSessionIds = Object.keys(checkedSessions);
        let filteredSelectedSessions = this.props.sessions.filter((session) => {
            return selectedSessionIds.includes(session._id);
        }).map((session) => {
            return {
                _id: session._id,
                name: session.name,
            };
        });
        this.props.batchUpdateSessions(filteredSelectedSessions, () => {
            this.setState({ submitting: false, success: true });
            this.props.toggle();
        });


    };


    updatedCheckedSessions = (checked) => {
        this.setState({ checkedSessions: checked });
    };

    render() {
        const {
            isOpen,
            toggle,
            sessions
        } = this.props;

        const {
            submitting,
            success,
            normalizedColumns,
            toggledColumns,
            selectedColumnSort,
            searchTerm,
            sortDesc,
            columnWidth,
            columns,
        } = this.state;
        let availableSessions = sessions;
        let data = availableSessions;
        if (searchTerm.length > 0) {
            const searchTerms = searchTerm.toLowerCase().split(' ');
            searchTerms.forEach((term) => {
                if (term != '') {
                    data = data.filter((entry) => {
                        let found = false;
                        Object.keys(columns).forEach((key) => {
                            if (term != '' && entry[key] && entry[key].toString().toLowerCase().includes(term)) {
                                found = true;
                            }
                        });
                        return found;
                    });
                }
            });
        }
        if (selectedColumnSort) {
            data = availableSessions.sort((a, b) => {
                const columnType = selectedColumnSort.type || typeof a[selectedColumnSort.key];
                if (a[selectedColumnSort.key] && b[selectedColumnSort.key]) {
                    switch (columnType) {
                        case 'string':
                            return a[selectedColumnSort.key]
                                .toLowerCase()
                                .trim()
                                .localeCompare(b[selectedColumnSort.key].toLowerCase().trim());
                        case 'number':
                            return a[selectedColumnSort.key] - b[selectedColumnSort.key];
                        case 'date':
                            return (
                                new Date(a[selectedColumnSort.key]).getTime() -
                                new Date(b[selectedColumnSort.key]).getTime()
                            );
                        case 'time':
                            return (
                                new Date(a[selectedColumnSort.key]).getTime() -
                                new Date(b[selectedColumnSort.key]).getTime()
                            );
                        case 'boolean':
                            const a1 = a[selectedColumnSort.key] ? 'yes' : 'no';
                            const b1 = b[selectedColumnSort.key] ? 'yes' : 'no';
                            return a1.localeCompare(b1);
                        default:
                            return a[selectedColumnSort.key]
                                .toLowerCase()
                                .trim()
                                .localeCompare(b[selectedColumnSort.key].toLowerCase().trim());
                    }
                } else if (a[selectedColumnSort.key]) {
                    return 1;
                }
                return -1;
            });

            availableSessions = sortDesc ? availableSessions.reverse() : availableSessions;
        }
        return (

            <div>
                <FieldModal
                    size="medium"
                    isOpen={isOpen}
                    modalTitle={"Connect to Sessions"}
                    bodyHeaderText={''}
                    bodyExtraText={<p className='pb-20' style={{ color: '#999999', marginTop: 0 }}>Select sessions to connect to the selected inventory</p>}
                    bodyContent={() => {
                        return (
                            <div style={{ paddingRight: 5 }}>
                                <InputField
                                    classes="viewSearch"
                                    placeholder="Search"
                                    clickIcon={true}
                                    required={true}
                                    value={searchTerm}
                                    onChange={(e) => {
                                        this.setState({ searchTerm: e.target.value });
                                    }}
                                    prefix={<i className="las la-search" style={{ marginRight: 5, transform: 'rotate(270deg)' }} />}
                                    inputIcon={searchTerm !== '' &&
                                        <i
                                            onMouseDown={() => this.setState({ searchTerm: '', searching: false })}
                                            //onClick={() => this.setState({ searchTerm: '', searching: false })}
                                            className="las la-times-circle"
                                            style={{ visibility: searchTerm == '' ? 'hidden' : 'visible' }}
                                        />}
                                />
                                <ViewsTable
                                    title="Sessions"
                                    style={{ margin: 0, height: 500 }}
                                    classes={"fit"}
                                    columns={normalizedColumns}
                                    toggledColumns={toggledColumns}
                                    data={data}
                                    mainColumnActive={false}
                                    columnWidths={columnWidth}
                                    checked={this.state.checkedSessions}
                                    checkRow={(entryId) => {
                                        const checked = this.state.checkedSessions;
                                        checked[entryId] ? delete checked[entryId] : (checked[entryId] = true);
                                        this.updatedCheckedSessions(checked);
                                    }}
                                    checkAllRows={(entryIds) => {
                                        let checked = this.state.checkedSessions;
                                        entryIds.length > 0
                                            ? entryIds.forEach((entryId) => {
                                                checked[entryId] = true;
                                            })
                                            : (checked = {});
                                        this.updatedCheckedSessions(checked);
                                    }}
                                    sortData={this.sortData}
                                />{' '}
                            </div>
                        )
                    }
                    }
                    toggle={toggle}
                    actionButtonLabel={!submitting ? 'Add' : 'Adding...'}
                    cancelButtonLabel={success ? 'Close' : false}
                    cancelOnClick={false}
                    actionButton={() => this.submit()}
                    submitting={submitting}
                    actionButtonDisabled={submitting || success}
                ></FieldModal >
            </div >
        )

    }
}

export default ConnectToSessions;
